export enum StorageKeys {
	UPN = "userPrincipalName",
	//#warning-ts: the difference between UPNForAzure and UPN is not clear
	UPNForAzure = "userPrincipalNameForAzure",
	UserName = "userName",
	TokenId = "tokenId",
	SIP = "SIP",
	CompanyId = "companyId", //we keep companyId with compatibility with V1 client
	TenantId = "companyKey", //we can't change the companyKey value as it is shared with V1 client
	UserId = "userId",
	//#warning-ts: MsUserObjectId should be equal to UserId; MsUserObjectId reflects the ms authentication one; the naming is not indicative of the role of the variable
	MsUserObjectId = "msUserObjectId",
	TokenADDelegated = "tokenADDelegated",
	FullName = "fullName",
	SuggestedContactsIds = "suggestedContactsIds",
	ChatHistory = "chatHistory",
	Language = "language",
	OutboundEndpoint = "outboundEndpoint",
	OnlyOnlineAgents = "OnlyOnlineAgents",
	ExternalProcessed = "externalProcessed",
	AlertMessage = "alertMessage",
	SupervisorQueueSelected = "supervisorQueueSelected",
	SupervisorCallsFilters = "supervisorCallsFilters",
	ServerClientTimeDifference = "serverClientTimeDifference",
	TIDForAzure = "tid",
	//#warning-ts: ServiceCallTimeout seems to be unused
	ServiceCallTimeout = "serviceCallTimeout",
	Exception = "exception",
	IsCustomerJourneyEnabled = "isCustomerJourneyEnabled",
	SessionExpiryTimestamp = "sessionExpiryTimestamp",
	UserwayKey = "UserwayKey",
	ExtendedMediaActiveTab = "extendedMediaActiveTab",
	GenericActiveTab = "genericActiveTab",
	CurrentWrapUpCodeId = "currentWrapUpCodeId",
	CurrentWrapUpCodeName = "currentWrapUpCodeName",
	Deployments = "deployments",
	MainViewTab = "MainViewTab",
	LastActiveGenericId = "LastActiveGenericId",
	BrowserSessionId = "browserSessionId",
	GenericMediaActiveTab = "GenericMediaActiveTab",
	DeploymentTenantKey = "td",
	DeploymentTenantId = "tdid",
	TokenGraphApi = "tokenGraphApi",
	TokenAcs = "tokenAcs",
	TeamsTheme = "teamsTheme",
}
